export const POLICY_ONWER_ANNUITY_DATA_REQUEST =
  'POLICY_ONWER_ANNUITY_DATA_REQUEST';
export const POLICY_ONWER_ANNUITY_DATA_SUCCESS =
  'POLICY_ONWER_ANNUITY_DATA_SUCCESS';
export const POLICY_ONWER_ANNUITY_DATA_FAIL = 'POLICY_ONWER_ANNUITY_DATA_FAIL';
